export const SLOT_TYPES = {
    Data: 1,
    Attachment: 2,
    Role: 3,
    Form: 4,
    // Status: 5, // Not currently used
    SendSignalName: 6,
    ReceiveSignalName: 7
};

export const DIRECTION_TYPES = {
    NoDirection: 0,
    FromPublishingProgram: 1,
    FromConsumingProgram: 2
};

export const CHANNEL_FILE_EXT = "pcsd";

export const SLOT_IDS = {
    ProjectTableOpenFormSignal: "OpenFormSignal"
};

export const NEW_GROUP_ID_BASE = "GROUP_";
export const NEW_MEMBER_ID_BASE = "MEMBER_";
